import { saveAs } from 'file-saver'
import moment from 'moment'
import Papa from 'papaparse'

export interface IIFImport {
  trns: string,
  trnsId: string,
  trnsType: string,
  date: string,
  account: string,
  name: string,
  class: string,
  amount: string,
  docNum: string,
  memo: string,
  clear: string,
  toprint: string
  addr5: string
  dueDate: string
  terms: string
}

function generateExportFile(
  records: [][]
) {
  const tsvText = Papa.unparse(records, {delimiter: '\t'})
  const formattedExportDate = moment().format('YYYY-MM-DD_HHmm')
  const tsvFilename = `SkilletWorks_Quickbooks_Export_${formattedExportDate}.iif`
  return new File([tsvText], tsvFilename, {
    type: 'text/tsv'
  })
}

const endTrns = [
  ['ENDTRNS'],
  [''],
  [''],
  [''],
  [''],
  [''],
  [''],
  [''],
  [''],
  [''],
  [''],
  [''],
  [''],
  [''],
  ['']
]

export async function generateIIF(objects: IIFImport[]) {
  const defaultRows = [
    [
      ['!TRNS'],
      ['TRNSID'],
      ['TRNSTYPE'],
      ['DATE'],
      ['ACCNT'],
      ['NAME'],
      ['CLASS'],
      ['AMOUNT'],
      ['DOCNUM'],
      ['MEMO'],
      ['CLEAR'],
      ['TOPRINT'],
      ['ADDR5'],
      ['DUEDATE'],
      ['TERMS']
    ],
    [
      ['!SPL'],
      ['SPLID'],
      ['TRNSTYPE'],
      ['DATE'],
      ['ACCNT'],
      ['NAME'],
      ['CLASS'],
      ['AMOUNT'],
      ['DOCNUM'],
      ['MEMO'],
      ['CLEAR'],
      ['QNTY'],
      ['REIMBEXP'],
      ['SERVICEDATE'],
      ['OTHER2']
    ],
    [
      ['!ENDTRNS'],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      [''],
      ['']
    ]
  ]

  const records = objects.reduce((acc, obj, index) => {
    if (!index) {
      acc.push(...defaultRows)
    }

    const tuples = [
      [obj.trns],
      [obj.trnsId],
      [obj.trnsType],
      [obj.date],
      [obj.account],
      [obj.name],
      [obj.class],
      [obj.amount],
      [obj.docNum],
      [obj.memo],
      [obj.clear],
      [obj.toprint],
      [obj.addr5],
      [obj.dueDate],
      [obj.terms]
    ]

    if (!index) {
      return [...acc, tuples]
    } else {
      return index === objects.length - 1
        ? [...acc, endTrns, tuples, endTrns]
        : [...acc, endTrns, tuples]
    }
  }, [] as any[])

  const tsv = generateExportFile(records)
  saveAs(tsv)
}
